import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { TextInputWTitleDisable } from './TextInputWTitleDisable'
const Styles = styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 0.5rem;
`

    // dokme chesm baray ramz ha

export const SelectDateInputDisabled = ({style, name, error, value, onchange, required, disabled}) => {
    const [year, setYear] = useState(1400);
    const [month, setMonth] = useState(1);
    const [day, setDay] = useState(1);

    useEffect(()=> {
        if(value){
            let temp = value.split('/');
            setYear(parseInt(temp[2]));
            setMonth(parseInt(temp[1]));
            setDay(parseInt(temp[0]));
        }
    },[value])
    return (
        <Styles style={style}>
            <TextInputWTitleDisable title={'year'} name={'year'} value={year}/>
            <TextInputWTitleDisable title={'month'} name={'month'} value={month}/>
            <TextInputWTitleDisable title={'day'} name={'day'} value={day}/>
        </Styles>
    )
}

// const kabiseh = 1399;

// const months = [
//     {
//       name: "فروردین",
//       days: 31,
//     },
//     {
//       name: "اردیبهشت",
//       days: 31,
//     },
//     {
//       name: "خرداد",
//       days: 31,
//     },
//     {
//       name: "تیر",
//       days: 31,
//     },
//     {
//       name: "مرداد",
//       days: 31,
//     },
//     {
//       name: "شهریور",
//       days: 31,
//     },
//     {
//       name: "مهر",
//       days: 30,
//     },
//     {
//       name: "آبان",
//       days: 30,
//     },
//     {
//       name: "آذر",
//       days: 30,
//     },
//     {
//       name: "دی",
//       days: 30,
//     },
//     {
//       name: "بهمن",
//       days: 30,
//     },
//     {
//       name: "اسفند",
//       days: 29,
//     },
// ];